const initialState = () => {
  return {
    errors:[],
    isPaymentSuccess:false,
    upgradeButtonVisibilityStatus:null,
  }
}
export default initialState



// WEBPACK FOOTER //
// ./src/store/modules/payment/initialState.js